import React, { useState, useRef } from 'react';
import { QuestionVersion } from '../../services/QuestionService';
import QuestionEdition from '../../components/QuestionEdition';
import QuestionCreation from '../../components/QuestionCreation';
import QuestionList, { QuestionListRef } from '../../components/QuestionList';
import AdminLayout from '../../components/AdminLayout';

interface Question {
  id: number; question: string; level: number; type_question: string; status: string;
  category: string; vector_db_data: string; data_type: string; additional_info?: string;
  created_at: string; updated_at: string; versions: QuestionVersion[];
}

const Question: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [showVersionsModal, setShowVersionsModal] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState<any>(null);
  const questionListRef = useRef<QuestionListRef>(null);

  const handleRowClick = (question: any) => { setSelectedQuestion(question); setShowVersionsModal(true); };
  const handleUpdate = () => { setShowModal(false); setShowVersionsModal(false); setSelectedQuestion(null); questionListRef.current?.fetchData(); };
  const handleUpdateOnly = () => { questionListRef.current?.fetchData(); };

  return (
    <AdminLayout>
      <div className="min-h-screen">
        <QuestionList ref={questionListRef} onRowClick={handleRowClick} onAddQuestion={() => setShowModal(true)} />
        {showModal && <QuestionCreation onClose={() => setShowModal(false)} onUpdate={handleUpdate} />}
        {showVersionsModal && selectedQuestion && <QuestionEdition question={selectedQuestion} onClose={() => setShowVersionsModal(false)} onUpdate={handleUpdateOnly} />}
      </div>
    </AdminLayout>
  );
};

export default Question;
